import React, { useRef, useState } from 'react';
import './Banner.style.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import {
  CaretRightOutlined,
  LeftOutlined,
  PauseOutlined,
  RightOutlined,
} from '@ant-design/icons';

const Banner = ({ slides = [] }) => {
  /* ===== Route ===== */

  /* ===== Props ===== */
  /* ===== State ===== */
  const nextRef = useRef(null);
  const prevRef = useRef(null);

  const [swiper, setSwiper] = useState(null);
  const [progress, setProgress] = useState(1);
  const [isAutoplay, setIsAutoplay] = useState(true);

  // console.log('swiper ====>', swiper);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /**
   * 배너 라우팅 처리
   * --
   * @param {object} banner
   * @returns
   */
  const handleClick = (banner) => {
    const { is_new_window, render_url } = banner;

    if (!render_url) return;

    if (is_new_window === 'Y') {
      window.open(render_url);
    } else {
      window.location.href = render_url;
    }
  };

  /**
   * 배너 일시정지/실행
   * --
   * @returns
   */
  const handleToggleAutoplay = () => {
    if (!swiper) return;

    if (isAutoplay) {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.start();
    }
    setIsAutoplay(!isAutoplay);
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div className="banner_layout">
      {/* 이미지 슬라이드 */}
      {prevRef.current && nextRef.current && (
        <Swiper
          // slidesPerView={1}

          //
          slidesPerView={'auto'}
          centeredSlides
          spaceBetween={30}
          //
          loop={true}
          className="main_banner_swiper"
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          onAutoplayTimeLeft={(swiper, time, prog) => {
            setProgress(1 - prog);
          }}
          modules={[Autoplay, Navigation]}
          // loop={slides?.length > 1 ? true : false}
          observer={true}
          observeParents={true}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
            setSwiper(swiper);
          }}
        >
          {slides.map((_item, _index) => (
            <SwiperSlide key={`banner_${_item.id}`}>
              <div
                onClick={() => handleClick(_item)}
                style={{
                  cursor: _item.render_url ? 'pointer' : 'default',
                  zIndex: 100,
                }}
              >
                {_item.content_type === 'IMG' ? (
                  <img
                    src={_item.url}
                    alt={_item.title}
                    width={'100%'}
                    height={'100%'}
                    fit={'cover'}
                  />
                ) : (
                  <video
                    src={_item.url}
                    width="100%"
                    height="100%"
                    playsInline // React에서는 playsInline로 사용
                    webkit-playsinline="true" // 하이픈이 포함된 속성은 문자열로 전달
                    muted
                    loop
                    autoPlay
                    controls={false}
                    disablePictureInPicture // Picture-in-Picture 모드를 비활성화
                    style={{ objectFit: 'cover' }}
                  />
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      )}


      {/* 버튼 */}
      {slides?.length > 1 ? (
        <div className="swiper_controller_wrapper">
          <div className="swiper_controller_container">
            <div className="banner_controller">
              <div ref={prevRef} onClick={() => swiper.slidePrev()}>
                <LeftOutlined />
              </div>
              <div ref={nextRef} onClick={() => swiper.slideNext()}>
                <RightOutlined />
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Banner;
